import VueRouter from 'vue-router';
import Modules from "./vueComponents/Modules";
import Vue from "vue";

Vue.use(VueRouter);

const routes = [
    {path: '*', component: Modules},
];

export default new VueRouter({
    mode: "history",
    routes
});
